// stores backend base URL - use localhost for development, Render for production
const BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://www.bulldogcarpool.com'
  : 'http://localhost:5001';
export default BASE_URL;